import React from 'react';

export default function() {
    return <>
        <p>A bit of thinking shows that \(n \in S_k\) if and only if {String.raw`\(\lfloor 2^{-k} n \rfloor = 2m+1\)`} is odd. Thus the sum becomes</p>
        {String.raw`\[\sum_{k=0}^\infty \sum_{m=0}^\infty \sum_{n=2^k \, (2m+1)}^{2^k \, (2m+2) - 1} \frac{1}{n^2 + n}.\]`}
        <p>Since {String.raw`\((n^2 + n)^{-1} = n^{-1} - (n+1)^{-1}\)`}, the inner sum telescopes, yielding</p>
        {String.raw`\[\sum_{k=0}^\infty \frac{1}{2^k} \sum_{m=0}^\infty \left[\frac{1}{2m+1} - \frac{1}{2m+2}\right] = 2 \ln{2}.\]`}
    </>;
}
